import template from './category-detail-topfeed.html.twig';
import './category-detail-topfeed.scss';
//const { mapState, mapGetters } = Shopware.Component.getComponentHelper();
const {Component, Mixin, Context, Data: {Criteria, EntityCollection}} = Shopware;

Component.register('category-detail-topfeed', {
    template: template,

    inject: ['repositoryFactory'],
    mixins: [
        Mixin.getByName('notification')
//        Mixin.getByName('listing')
    ],

    data() {
        return {
            test:              'test-value',
            isLoading:         true,
            currentLanguageId: Shopware.Context.api.languageId,
            feedSettings:      null, // v-model, fetched from server
            category:          null,
            categoryExtension: null
        };
    },

    metaInfo() {
        return {
            title: this.$t('TopdataTopfeedSW6.tabCategorySettingsMetaTitle')
        };
    },

    props: {
        isLoading: {
            type:     Boolean,
            required: true
        }
    },

    computed: {
        topdataCategoryExtensionRepository() {
            return this.repositoryFactory.create('topdata_category_extension');
        }
    },

    created() {
        this.category = Shopware.Store.get('swCategoryDetail').category;
        this.isLoading = true;
        this.loadCategoryFeedSettings();
        this.isLoading = false;
    },

//    watch: {
//        category() {
//        }
//    },

    methods: {
        loadCategoryFeedSettings() {
            var criteria = new Criteria();
            criteria.addFilter(Criteria.equals('categoryId', this.category.id));
            this.topdataCategoryExtensionRepository.search(criteria, Shopware.Context.api).then((result) => {
                // console.log(result);
                let model = result.first();
                if (model) {
                    this.feedSettings = model;
                } else {
                    this.feedSettings = this.topdataCategoryExtensionRepository.create(Shopware.Context.api);
                    this.feedSettings.pluginSettings = true;
                    this.feedSettings.categoryId = this.category.id;
                    this.feedSettings.importSettings = {
                        name:              false,
                        description:       false,
                        brand:             true,
                        EANs:              true,
                        MPNs:              true,
                        pictures:          true,
                        unlinkOldPictures: false,
                        properties:        true,
                        PCDsProp:          false,
                        MPNsProp:          false,

                        importSimilar:          true,
                        importAlternates:       true,
                        importAccessories:      true,
                        importBoundles:         true,
                        importVariants:         true,
                        importColorVariants:    true,
                        importCapacityVariants: true,

                        crossSimilar:          false,
                        crossAlternates:       false,
                        crossAccessories:      false,
                        crossBoundles:         false,
                        crossVariants:         false,
                        crossColorVariants:    false,
                        crossCapacityVariants: false
                    };
                }
            });
        },

        saveCategoryFeedSettings() {
            console.log("saveCategoryFeedSettings");
            this.isLoading = true;
            this.topdataCategoryExtensionRepository
                .save(this.feedSettings, Shopware.Context.api)
                .then(() => {
                    // this.loadCategoryFeedSettings();
                    this.createNotificationSuccess({
                        title:   this.$t('TopdataTopfeedSW6.notification.saveSuccessTitle'),
                        message: this.$t('TopdataTopfeedSW6.notification.saveSuccessDescription')
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    },
    watch:   {
        feedSettings: {
            handler(newValue, oldValue) {
                if(oldValue === null) {
                    return;
                }
                // console.log("feedSettings changed");
                this.saveCategoryFeedSettings();
            },
            deep:      true,
            immediate: false,
        },
    },
});